import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import { RegisterFormState } from './registerTypes';

interface RegisterStepDescriptionProps {
  form: RegisterFormState;
  update: (patch: Partial<RegisterFormState>) => void;
  onContinue: () => void;
  onBack: () => void;
}

const RegisterStepDescription: React.FC<RegisterStepDescriptionProps> = ({
  form,
  update,
  onContinue,
  onBack,
}) => {
  const { t } = useTranslation();

  const canContinue = form.description.trim().length > 0;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (canContinue) onContinue();
  };

  return (
    <div className="register__card">
      <h1 className="register__title italic-title">{t.register.descriptionTitle}</h1>
      <p className="register__subtitle">{t.register.descriptionSubtitle}</p>

      <form className="register__form" onSubmit={handleSubmit}>
        <div className="register__field">
          <label htmlFor="description" className="register__label">{t.register.descriptionLabel}</label>
          <textarea
            id="description"
            className="register__textarea"
            rows={5}
            placeholder={t.register.descriptionPlaceholder}
            value={form.description}
            onChange={(e) => update({ description: e.target.value })}
          />
        </div>

        <div className="register__nav">
          <button type="button" className="register__back" onClick={onBack}>
            {t.register.back}
          </button>
          <button type="submit" className="register__submit button_primary" disabled={!canContinue}>
            {t.register.continue}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegisterStepDescription;
